import { InfracaoMotivo, InfracaoTransporte } from "@tivic-team/manager-ts/dist/mob";

export class InfracaoTransporteDTO extends InfracaoTransporte{

    infracaoMotivo: InfracaoMotivo[] = void(0);

    constructor(
        infracaoMotivo?: InfracaoMotivo[]
    ){
        super();
        this.infracaoMotivo = infracaoMotivo;
    }
}

export class InfracaoTransporteDTOList {
    items: Array<InfracaoTransporteDTO>;
    total: number;

    constructor() {}
}